import {CustomerStatistics} from '../model/shared/statistics';
import {BaseResponse} from './internal/baseresponse';
export class UserStatisticsResult extends BaseResponse {
  data?: Array<CustomerStatistics> = new Array<CustomerStatistics>();
}



// WEBPACK FOOTER //
// ./src/app/response/userstatisticsresult.ts